import { gql } from '@apollo/client';

export const GET_SETTLEMENT_LIST_BY_FILTER = gql`
  query GetSettlementListByFilter(
    $filter: SettlementFilterInput
    $page: Int
    $size: Int
  ) {
    settlement {
      settlements(filter: $filter, page: $page, size: $size) {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            id
            periodCode
            title
            totalPayment {
              value
              currencyCode
            }
            totalFee {
              value
              currencyCode
            }
            host {
              id
              name
            }
            startedDate
            endedDate
            invoice {
              id
              title
              status
              createdAt
              completedAt
              feeForReceivable {
                value
                currencyCode
              }
            }
            createdAt
          }
        }
      }
    }
  }
`;

export const REQUEST_INVOICE = gql`
  mutation RequestInvoice($param: InvoiceParamInput!) {
    requestInvoice(param: $param) {
      id
      status
      settlements {
        id
        periodCode
        title
        totalPayment {
          value
          currencyCode
        }
        totalFee {
          value
          currencyCode
        }
        host {
          id
          name
        }
        startedDate
        endedDate
        invoice {
          id
          title
          status
          createdAt
          completedAt
        }
        createdAt
      }
    }
  }
`;
